/*****
 * ====================================================================================
 * Project: noloNearbyLawyers jQuery Plugin
 * Description: provide a means to retrieve a nearby lawyers and related information
 * Author: Nicholas Hughes @ Nolo
 * Version: 1.1.6
 * jQuery Version: 2.1.4
 * ====================================================================================
 *
 * @version_history
 * 1.0.0
 * + initial plugin creation
 *
 * 1.0.1
 * + define a default practice area option as the fallback
 *
 * 1.0.2
 * + append domain parameter to lawyer widget links
 * + fix undefined city and state in url, conv spaces to hyphens
 *
 * 1.0.3
 * + Two new versions of ldc directory widget added
 *
 * 1.0.4
 * + Created more functions and changed domain creation standards
 *
 * 1.0.5
 * + all links now have rel='nofollow'
 * + moved tracking to functions attached to links through jquery click handlers
 *
 * 1.1.0
 * + refactor to support mobile
 *
 * 1.1.1
 * + Changed jquery selector for new footer for tracking
 *
 * 1.1.2
 * + update 'view all' link to use the state name over state code consistently
 *
 * 1.1.3
 * + add option to disable GEOC API
 *
 * 1.1.4
 * + add option to relocate widget
 *
 * 1.1.5
 * + correct the Nolo:LDC AoP mapping
 * + correct the Peer/Client Rating display
 *
 * 1.1.6
 * + add option to specify the LDC domain root
 */




// noloNearbyLawyers JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloNearbyLawyers PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var nearbyLawyers = function (element, options) {
        this.$element  = $(element);
        this.options   = $.extend({}, nearbyLawyers.DEFAULTS, this.getDataAttributeOptions(), options);

        // Initialize the plugin
        this.init();
    }




    // noloNearbyLawyers PLUGIN NAMESPACE
    // ================================================================================
    nearbyLawyers.NAMESPACE  = 'nolo';
    nearbyLawyers.NAME       = 'noloNearbyLawyers';
    nearbyLawyers.DATAID     =  nearbyLawyers.NAMESPACE + '.' + nearbyLawyers.NAME;




    // noloNearbyLawyers VERSION
    // ================================================================================
    nearbyLawyers.VERSION  = '1.1.6';




    // noloNearbyLawyers CONTANTS
    // ================================================================================
    nearbyLawyers.CONSTANTS = {
        // 'apiUrl': '//profile-services.stg3.lawyers.com/services/search/v1/composite', //staging
        'apiUrl': '//profile-services.lawyers.com/services/search/v1/composite', //production
        'zipApiUrl': '//geocoding.internetbrands.com/geocoding/api/v1.1/getCityStateZipCode',
        'aopMap': {
            'airplanebusinesstransactions': 'Aviation Law',
            'asbestos': 'Mesothelioma',
            'autoaccident': 'Auto Accidents',
            'aviationaccidents': 'Airplane Crash Lawsuits',
            'bankruptcy': 'Bankruptcy',
            'business': 'Corporate Law',
            'childcustody': 'Child Custody and Visitation',
            'childsupport': 'Child Support',
            'civilrights': 'Civil Rights',
            'commercialrealestate': 'Commercial Real Estate',
            'consumerprotection': 'Consumer Law',
            'criminaldefense': 'Criminal Law',
            'debtsettlement': 'Debtor and Creditor',
            'disability': 'Social Security Disability',
            'divorce': 'Divorce',
            'duianddwi': 'Dui/Dwi & Traffic Violations',
            'employment': 'Your Job and The Law',
            'estateplanning': 'Estate Planning',
            'expungement': 'Expungements',
            'family': 'Your Family & The Law',
            'foreclosure': 'Foreclosure',
            'immigration': 'Law Immigration',
            'intellectualproperty': 'Intellectual Property',
            'landlordandtenant': 'Landlord and Tenant',
            'litigation': 'Alternative Dispute Resolution',
            'maritime': 'Maritime',
            'medicalmalpractice': 'Medical Malpractice',
            'militarydivorce': 'Military Divorce',
            'patents': 'Patents',
            'personalinjury': 'Personal Injury',
            'productliability': 'Product Liability',
            'realestate': 'Your Home and The Law',
            'securities': 'Securities',
            'sexcrimes': 'Sexual Crimes',
            'sexualharassment': 'Sexual Harassment',
            'socialsecuritydisability': 'Social Security Disability',
            'ssdi': 'Social Security Disability',
            'tax': 'Taxation',
            'traffictickets': 'Traffic Violations',
            'uscitizenship': 'U.S. Citizenship',
            'usvisa': 'Visas',
            'workerscompensation': 'Workers Compensation',
            'wrongfultermination': 'Wrongful Termination'
        },
        'statesMap':{
            'AL' : 'Alabama',
            'AK' : 'Alaska',
            'AZ' : 'Arizona',
            'AR' : 'Arkansas',
            'CA' : 'California',
            'CO' : 'Colorado',
            'CT' : 'Connecticut',
            'DE' : 'Delaware',
            'DC' : 'District of Columbia',
            'FL' : 'Florida',
            'GA' : 'Georgia',
            'HI' : 'Hawaii',
            'ID' : 'Idaho',
            'IL' : 'Illinois',
            'IN' : 'Indiana',
            'IA' : 'Iowa',
            'KS' : 'Kansas',
            'KY' : 'Kentucky',
            'LA' : 'Louisiana',
            'ME' : 'Maine',
            'MD' : 'Maryland',
            'MA' : 'Massachusetts',
            'MI' : 'Michigan',
            'MN' : 'Minnesota',
            'MS' : 'Mississippi',
            'MO' : 'Missouri',
            'MT' : 'Montana',
            'NE' : 'Nebraska',
            'NV' : 'Nevada',
            'NH' : 'New Hampshire',
            'NJ' : 'New Jersey',
            'NM' : 'New Mexico',
            'NY' : 'New York',
            'NC' : 'North Carolina',
            'ND' : 'North Dakota',
            'OH' : 'Ohio',
            'OK' : 'Oklahoma',
            'OR' : 'Oregon',
            'PA' : 'Pennsylvania',
            'RI' : 'Rhode Island',
            'SC' : 'South Carolina',
            'SD' : 'South Dakota',
            'TN' : 'Tennessee',
            'TX' : 'Texas',
            'UT' : 'Utah',
            'VT' : 'Vermont',
            'VA' : 'Virginia',
            'WA' : 'Washington',
            'WV' : 'West Virginia',
            'WI' : 'Wisconsin',
            'WY' : 'Wyoming'
        },
    }




    // noloNearbyLawyers DEFAULT OPTIONS
    // ================================================================================
    nearbyLawyers.DEFAULTS = {
        // use GEOC API
        'geolocate': true,
        // data-dom-target = to override where the element will be placed
        'domTarget': '.node-type-article .node-content',
        // data-element-depth = to override how deep within element the block will be put
        'elementDepth': 1,
        // data-page-size = the amount of results per api call
        'pageSize': 10,
        // data-aop = the aop that will be used for the profile services api
        'aop': 'bankruptcy',
        // data-domain-url = bool that when true means we use domain.lawyers.com and false means we use lawyers.com urls without the domain
        'domainUrl': false,
        // data-version = name of the styling of the block
        'version': 'nearby-lawyers',
        // data-header = content of header block
        'header': '',
        // data-footer = content of footer block
        'footer': '',
        // data-mobile-size = at what pixel width do we switch between mobile and desktop view
        'mobileSize': 768,
        // data-api-data-type = specify dataType for the AJAX call to lawyers.com
        'apiDataType': 'json',
        // moves the element to the location defined in data-dom-target
        'relocate': false,
        // options automatically populated upon initialization, declared for reference
        'requestAop': null,
        'zip': null,
        'city': null,
        'stateName': null,
        'stateCode': null,
        'domainRoot': 'lawyers.com'
    }




    // noloNearbyLawyers PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    nearbyLawyers.prototype.init = function(){
        // get the aop Map
        // -----
        // @note:
        // + only a few of LDC's practice areas or aop are mapped to Nolo's aop
        var aopMap  = nearbyLawyers.CONSTANTS.aopMap;

        // grab the detect Nolo aop
        var currentAop = this.getOptions('aop').replace(/\s+/g, '').toLowerCase();

        // check if we will use geolocation
        var geolocate = this.getOptions('geolocate');

        // store the request AOP into the plugin options
        if(typeof aopMap[currentAop] !== 'undefined') {
            this.options.requestAop = aopMap[currentAop];
        }

        // grab the zip code
        if (geolocate){
            this.getZipCode();
        }

        return;
    }

    nearbyLawyers.prototype.getDataAttributeOptions = function(){
        var options = (typeof $.Deferred === 'function') ? this.$element.data() : {};
        return options;
    }

    nearbyLawyers.prototype.getOptions = function(key){
        var options = this.options;
        return (typeof key !== 'undefined') ? options[key] : options;
    }

    nearbyLawyers.prototype.getZipCode = function() {
        var process = this;

        if(typeof $.Deferred === 'function'){
            var promise = $.ajax({
                url: nearbyLawyers.CONSTANTS.zipApiUrl,
                type: 'GET',
                dataType: 'json',
            });

            // on success, continue process
            promise.done(function(data, status, xhr){
                process.options.zip = data.zipCode;
                process.options.city = data.city || "all-cities";
                process.options.stateName = data.state.stateName;
                process.options.stateCode = data.state.isoCode;
                process.getLawyerData();
                return;
            });

            // catch ajax errors
            promise.fail(function(xhr, status, error){
                return;
            });
        }

        return;
    }


    nearbyLawyers.prototype.getLawyerData = function() {
        var process = this;
        var aop = process.getOptions('requestAop');
        var zip = process.getOptions('zip');
        var state = process.getOptions('stateName');
        var city = process.getOptions('city');

        // a valid 'aop' is required in order to generate the nearby lawyers block
        if (!aop){
            return;
        }

        if(typeof $.Deferred === 'function'){
            var data = {};
            data.aop = aop;
            data.pageSize = process.getOptions('pageSize');
            if(typeof zip !== 'undefined') {
                data.zip = zip;
            } else if(typeof state !== 'undefined') {
                data.state = state;
                if(typeof city !== 'undefined') {
                    data.city = city;
                }
            }

            // create the promise
            var promise = $.ajax({
                type: 'GET',
                crossDomain: true,
                url: nearbyLawyers.CONSTANTS.apiUrl,
                data: data,
                dataType: process.getOptions('apiDataType'),
            });

            // on success, continue process
            promise.done(function(data, status, xhr){
                process.createElements(data);
                return;
            });

            // catch ajax errors
            promise.fail(function(xhr, status, error){
                return;
            });
        }
        return;
    }

    nearbyLawyers.prototype.createElements = function(data) {
        var results = data.results;
        var $elm    = this.$element;
        var totalResults = results.Organic.itemsFound;
        if(totalResults == 0){
            return;
        }
        var count = totalResults < 3 ? totalResults : 3;
        var organicResults = results.Organic.results;

        // we need table-container for pages like this one: divorcenet.com/resources/child-custody/california-custody-modification-childs-preference-defenses.html
        var object = '<div class="table-container"> <div class="nearby-lawyers-block">';

        //title
        object += this.createTitle(totalResults);
        //change location modal
        object += this.createChangeLocationModal();

        object += "<div class='lawyer-body'>";
        for(var i = 0; i < count; i++) {
            var current = organicResults[i];
            var score = {
                'peer': current.prr,
                'client': current.crr
            };
            var phone = current.callTrackingNumber != '' ? current.callTrackingNumber : current.displayPhoneNumber;

            //lawyer block
            object += this.createLawyerBlock(current, score, phone);
        }

        //footer if more than 3 lawyers found
        if(totalResults > 3) {
            object += '<div>' + this.createFooter(totalResults) + '</div>';
        }

        object += '</div><span class="swipe-text">Swipe to view more</span></div></div>';

        //in case we're updating, we want to delete original
        $elm.find('.table-container').remove();

        //version is now defined by the data attribute, not the class name, so add it as a class from specified version
        $elm.addClass(this.getOptions('version'));
        $elm.append(object);

        if (this.options.relocate) {
            this.relocateWidget();
        }

        $elm.show();

        var process = this;
        //tracking
        $elm.find('.firm-title-link, .email-link').each( function(index){ $(this).on('click', function(){ process.trackFunction()}) });
        $elm.find('.container-footer').each( function(index){ $(this).on('click', function(){ process.trackFunction('view-all')}) });

        $elm.find('.change-location-link, .close-x').click(function() {
            var stateCode = process.getOptions('stateCode');
            $elm.find('.nearby-lawyers-block select[name="state"]').val(stateCode);
            $elm.find('.nearby-lawyers-block .change-location').toggle();
        });

        $elm.find('.submit-change-location').click(function() {
            process.changeLocation();
        });

        $elm.find('.change-location #city-value').keypress(function(e){
            if (e.keyCode == 13){
              // Enter pressed
              process.changeLocation();
            }
        });

        // define slick options
        var slickOptions = {
            'prevArrow': '<span class="slick-prev" aria-label="previous"></span>',
            'nextArrow': '<span class="slick-next" aria-label="next"></span>'
        };

        // use the 'enter.nRH.mobile' event from 'noloResponsiveHelper' to trigger the carousel init
        $(document).bind('enter.nRH.mobile', function() {
            $elm.find('.lawyer-body').slick(slickOptions);
        });

        // use the 'leave.nRH.mobile' event from 'noloResponsiveHelper' to trigger the carousel 'unslick' method
        $(document).bind('leave.nRH.mobile', function() {
            $elm.find('.lawyer-body.slick-initialized').slick('unslick');
        });

        if($('body').data('nolo.noloResponsiveHelper').isMobile()) {
            // convert the widget into a carousel
            $elm.find('.lawyer-body').slick(slickOptions);
        } else {
            // revert the widget back to a pre-carousel state
            $elm.find('.lawyer-body.slick-initialized').slick('unslick');
        }
    }

    nearbyLawyers.prototype.relocateWidget = function() {
        var $elm    = this.$element;
        var $target = $(this.options.domTarget + ' > :nth-child(' + this.options.elementDepth + ')');
        $target.after($elm);
    }

    nearbyLawyers.prototype.createTitle = function(totalResults) {
        // var version = this.getOptions('version');
        var headerContent = $.trim(this.getOptions('header'));
        var header = '';

        if(headerContent !== '') { //if we specify the header content
            header = headerContent;
        }
        var versionDiv = "<div class='container-header'>"+header+"</div>";
        var PALocationString = "<div class='container-title'>" + this.generatePAInLocationString(totalResults) + "<a rel='nofollow' class='change-location-link'> change location</a></div>";


        return versionDiv + PALocationString;
    }

    nearbyLawyers.prototype.createStateSelect = function() {
        var states = nearbyLawyers.CONSTANTS.statesMap;
        var returnValue;
        var options = '<option value="">Select</option>';

        for (var code in states) {
            options += '<option value="'+code+'">'+states[code]+'</option>';
        }

        return '<div class="state-input">State*<br /><select class="state-list" class="form-control" name="state">' + options + '</select><span class="error">Please Select State</span></div>';
    }

    nearbyLawyers.prototype.createChangeLocationModal = function() {
        var states = this.createStateSelect();
        var returnValue = "<div class='change-location'><div class='close-x'>✖</div>" + states;

        returnValue += "<div class='city-input'>City<br><input id='city-value' name='city' type='text' placeholder='City' maxlength='50'></div>\
            <span class='mandate'>* State is required</span>\
            <button class='btn btn-nolo-green submit-change-location'>Update</button>\
            </div>";

        return returnValue;
    }

    nearbyLawyers.prototype.createLawyerBlock = function(current, scores, phone){
        var domain = this.getDomain();
        var returnValue = "<div class='lawyer-block'>\
            <div class='firm-title'><a class='firm-title-link' target='_blank' rel='nofollow' href='http://"+this.generateDomain()+current.ldcStaticFirmUrl+domain+"'>" + current.firmName + "</a></div><div>";

        returnValue += "<span class='rating-sprites'>";

        var score = scores.peer || scores.client;
        var hasPeerScore = (scores.peer !== null);
        var hasClientScore = (scores.client !== null);
        var scoreString;

        if(hasPeerScore || hasClientScore) {
            var currentScore = parseFloat(score);
            var className = '';
            scoreString = "<span class='lawyer-score'>"+score+"</span>/5.0 ";

            if (hasPeerScore) {
                if(score >= 4.5) {
                    scoreString += "AV Rating";
                } else if(score >= 3.0 && score <= 4.4) {
                    scoreString += "BV Rating";
                } else {
                    scoreString += "Rating";
                }
            } else {
                scoreString += "Client Rating";
            }

            //calculating sprite picture here
            for(var i = 0; i < 5; i++) {
                className = '';
                if(currentScore - 1 > 0 || currentScore == 1) { //full star
                    currentScore -= 1;
                    className = 'full';
                } else if(currentScore == 0){ //only empty stars now
                    className = 'empty';
                } else { //sprite is a decimal value
                    if(currentScore > .66) {
                        className = 'seventy-five';
                    } else if(currentScore > .33) {
                        className = 'fifty';
                    } else {
                        className = 'twenty-five';
                    }
                    currentScore = 0;
                }
                returnValue += "<span class='"+className+"'></span>";
            }
        } else {
            scoreString = "N/A"
            for(var i = 0; i < 5; i++) {
                returnValue += "<span class='empty'></span>";
            }
        }
        returnValue += "</span>";

        returnValue += "<span class='rating'>"+scoreString+"</span></div>\
            <div class='contact-block'><span class='contact-info'><span class='phone-icon'></span><a rel='nofollow' href='tel:"+phone+"'>"+phone+"</a></span>\
            <span class='contact-info'><span class='email-icon'></span><a class='email-link' rel='nofollow' href='http://"+this.generateDomain()+current.ldcStaticFirmUrl+"contact/"+domain+"'>CONTACT</a></span>\
            </div></div>";

        return returnValue;
    }

    nearbyLawyers.prototype.createFooter = function(totalResults) {
        var city = this.getOptions('city') || "all-cities";
        var state = this.getOptions('stateName') || "all-states";
        // var version = this.getOptions('version');
        var footerContent = $.trim(this.getOptions('footer'));
        var aop = this.getOptions('aop');
        var domain = this.getDomain();
        var footer = '';

        if(footerContent !== '') { //if we specify footer content
            footer = footerContent;
        } else { //default
            footer = '<span class="see-more">See More</span><span class="paLocationString"> ('+this.generatePAInLocationString(totalResults)+')</span>';
        }

        var returnValue = "<a class='container-footer' rel='nofollow' target='_blank' href='http://"+this.generateDomain()+'/'+this.standardizeString(aop)+"/"+this.standardizeString(city)+"/"+this.standardizeString(state)+"/law-firms/"+domain+"'>" + footer + '</a>';
        return returnValue;
    }

    nearbyLawyers.prototype.trackFunction = function(type) {
        window.optimizely = window.optimizely || [];

        if(type === 'view-all'){
            _gaq.push(["_trackPageview", "/ldc-directory-widget-view-all-click"]);
            window.optimizely.push(["trackEvent", "ldc_directory_widget_view_all_click"]);
        } else {
            _gaq.push(["_trackPageview", "/ldc-directory-widget-click"]);
            window.optimizely.push(["trackEvent", "ldc_directory_widget_click"]);
        }
    }

    nearbyLawyers.prototype.changeLocation = function() {
        if(this.validateLocation()){
            this.getLawyerData();
            this.$element.find('.nearby-lawyers-block .change-location').toggle();
        }
    }

    nearbyLawyers.prototype.validateLocation = function() {
        var $elm  = this.$element;
        var code = $elm.find('select[name="state"]').val();
        var states = nearbyLawyers.CONSTANTS.statesMap;

        if(code === '') {
            $elm.find('.change-location .error').show();
            return false;
        } else {
            this.options.stateCode = code;
            this.options.stateName = states[code];
            this.options.city = $elm.find('input[name="city"]').val() || "all-cities";
            delete this.options.zip;
            return true;
        }
    }

    nearbyLawyers.prototype.generatePAInLocationString = function(totalResults) {
        var aop = this.getOptions('aop');
        var city = this.getOptions('city');
        var stateName = this.getOptions('stateName');
        var stateCode = this.getOptions('stateCode');
        var location;

        if(typeof city !== 'undefined' && city !== 'undefined' && city !== 'all-cities') {
            location = this.toTitleCase(city) + ', ' + stateCode;
        } else {
            location = stateName;
        }

        return '<span class="totals">' + totalResults + '</span><span> ' + aop + ' Law Firms in ' + location + '</span>';
    }

    nearbyLawyers.prototype.standardizeString = function(inputString) {
        return inputString.replace(/ /g, '-').toLowerCase();
    }

    nearbyLawyers.prototype.toTitleCase = function(str){
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    nearbyLawyers.prototype.generateDomain = function() {
        if(this.getOptions('domainUrl') === true || this.getOptions('domainUrl') === 1) {
            var splitDomain = window.location.hostname.split('.');
            return splitDomain[splitDomain.length - 2] + '.' + this.getOptions('domainRoot');
        } else {
            return 'www.' + this.getOptions('domainRoot');
        }
    }

    nearbyLawyers.prototype.getDomain = function() {
        var subDomainList = ['www', 'localhost', 'stg', 'stg1', 'stg2', 'stg3', 'stg4'];
        var host = window.location.host;
        var subDomain = host.split('.')[0];

        if (host.split('.').length === 3 && subDomainList.indexOf(subDomain) > -1) {
            return "?domain=" + host.substr(subDomain.length +1);
        } else {
            return "?domain=" + host;
        }
    }


    // noloNearbyLawyers PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function () {
            var $this   = $(this);
            var data    = $this.data(nearbyLawyers.DATAID);
            var options = typeof option == 'object' && option;

            // store the instance of this plugin for this element into memory, if none exists
            if (!data) $this.data(nearbyLawyers.DATAID, (data = new nearbyLawyers(this, options)));

            // call a public method
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }



    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[nearbyLawyers.NAME];

    // assign the nearbyLawyers PLUGIN DEFINITION
    $.fn[nearbyLawyers.NAME] = Plugin;

    // assign the nearbyLawyers PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[nearbyLawyers.NAME]['constructor'] = nearbyLawyers;

    // noloNearbyLawyers NO CONFLICT
    // ================================================================================
    $.fn[nearbyLawyers.NAME]['noConflict'] = function () {
        $.fn[nearbyLawyers.NAME] = old;
        return this;
    }



    // noloNearbyLawyers DATA-API
    // ================================================================================
    $(document).ready(function(){
        var $elm = $('[data-toggle~="noloNearbyLawyers"]'),
        option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });




}(jQuery, window, document);
